class Controller {
  constructor($injector, $stateParams, Events) {
    "ngInject";
    this.Events = Events;
    this.$stateParams = $stateParams;
    this.CityTransforms = $injector.get("CityTransforms");
  }
  $onInit() {
    this.isDisabled = true;
    this.title = this.optionTitle;
    this.unit = this.optionUnit;
    this.edit = () => {
      this.isDisabled = false;
    };

    this.save = () => {
      this.isDisabled = true;
      if (this.optionObj) {
        this.Events.emit(this.eventName, this.optionObj.value);
      }
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/optionField/optionField.controller.js